import React, {Component} from 'react';
import DxCodesInformation from "../confirm/requisition-details/DxCodesInformation";

class PanelDetails extends Component {

	render() {
        const req = this.props.reqResponses;
        const reqStructure = this.props.requsitionStructure;
        if (!req || !reqStructure) {
            return (null);
        }

        let panel;
        let components = [];
        let addOns = [];

        panel = reqStructure.orderableItem.inputFields
            .filter( (field) => field.id === Number(req.panel) );

        let selectedComponentIds = req.components;
        let selectedAddonIds = req.addons;
        let hasSelectedComponents = (selectedComponentIds && selectedComponentIds.length > 0 );
        let hasSelectedAddons = (selectedAddonIds && selectedAddonIds.length > 0 );

        // Loop through each profile to find matching components and add ons
        if( (hasSelectedComponents || hasSelectedAddons) && reqStructure.orderableItem && reqStructure.orderableItem.profileList ) {
            for (var i = 0; i < reqStructure.orderableItem.profileList.length; i++) {
                let profile = reqStructure.orderableItem.profileList[i];
                // Compare each profileComponent to the components list
                if( hasSelectedComponents ) {
                    let profileComponents = profile.profileComponents
                        .filter( component => selectedComponentIds.indexOf(""+component.id) > -1 );
                    if( profileComponents.length > 0 ) {
                        components.push( profileComponents
                            .map( (item, index) => <li className="col-sm-6 col-md-4" key={index}>{item.name}</li> )
                        );
                    }
                }
                // Compare each addOnList item to the gear-req addon list
                if( hasSelectedAddons ) {
                    let profileAddons = profile.addOnList
                        .filter( addon =>  selectedAddonIds.indexOf(""+addon.id) > - 1 );
                    if( profileAddons.length > 0 ) {
                        addOns.push( profileAddons
                            .map( (item, index) => <li className="col-sm-6 col-md-4" key={index}>{item.name}</li> )
                        );
                    }
                }
            }
        }

		const heading = this.props.heading === undefined ? 'Test Information' : this.props.heading;
        return (
            <div id="panelInfo">
                <h4>{heading}</h4>
                {panel !== null && panel.length > 0 && panel[0].name !== null &&
                    <div className="row space-bottom">
                        <div className="col-sm-12">
                            <strong>Panel</strong>
                            <ul className="list-unstyled"><li className="col-sm-12">{panel[0].name}</li></ul>
                        </div>
                    </div>
                }
                {components && components.length > 0 &&
                    <div className="row space-bottom">
                        <div className="col-md-12">
                            <strong>Test Components</strong>
                            <ul className="list-unstyled">{components}</ul>
                        </div>
                    </div>
                }
                {addOns && addOns.length > 0 &&
                    <div className="row space-bottom">
                        <div className="col-md-12">
                            <strong>Add-Ons</strong>
                            <ul className="list-unstyled">{addOns}</ul>
                        </div>
                    </div>
                }
                <DxCodesInformation
                    gearOrder={this.props.gearOrder}
                    requisition={this.props.requisition}
                    req={req}
                    omsRequisition={this.props.omsRequisition}
                    userInfo={this.props.userInfo}
                    editingReq={this.props.editingReq}
                    editingSection={this.props.editingSection}
                    editRef={this.props.editRef}
                    cancelEdit={this.props.cancelEdit}
                    saveEdit={this.props.saveEdit}
                    isEditSaveInProgress={this.props.isEditSaveInProgress}
                    inlineSaveError={this.props.inlineSaveError}
                    getWorkflowStep={this.props.getWorkflowStep}
                    editSection={this.props.editSection}
                    lastSavedReq={this.props.lastSavedReq}
                    lastSavedSection={this.props.lastSavedSection}
                    canEditDiagnosis={this.props.canEditDiagnosis}
                />
            </div>
        );
    }

}
export default PanelDetails;
